/* Handle event where user clicks outside our component */
function clickOutside(el, binding, vnode) {
    const contents = document.querySelector('.finexplorer-dev');
    el.clickOutsideEvent = function (event) {
        //restricted to page section class="finexplorer-dev" so website menu dropdown links work
        if (!(el == event.target || el.contains(event.target)) && contents.contains(event.target)) {
            vnode.context[binding.expression](event);
            event.stopPropagation();
        }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
}

function clickOutsideUnbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
}

export { clickOutside, clickOutsideUnbind };